import { OfflineStatus } from "@/components/offline";
import { SidebarProvider } from "@/components/ui/sidebar";
import { useLocation } from "react-router-dom";
import ErrorBoundary from "./components/ErrorBoundary";
import Sidebar from "./components/Sidebar";
import { UpdatePrompt } from "./components/UpdatePrompt";
import { PropsWithChildren } from "react";

export function DesktopLayout({ children }: PropsWithChildren) {
  const location = useLocation();

  return (
    <SidebarProvider>
      <OfflineStatus />
      <Sidebar />
      <main className="flex flex-col min-h-0 min-w-0 p-2 w-[inherit] bg-sidebar">
        <ErrorBoundary resetKey={location.pathname}>
          <UpdatePrompt />
          {children}
        </ErrorBoundary>
      </main>
    </SidebarProvider>
  );
}
